<template>
  <el-dialog v-dialog-drag='{width: "80vw", height: "90vh", marginTop: "5vh", isFullscreen: false}'
             :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='1050px'>
    <el-form v-loading='dialogLoading' :model='form' label-width='80px' label-position='right'
             :rules='rules'
             ref='ruleForm' class='settlement-form mt20' :inline='true'>
      <el-form-item v-if='dialogTitle === "新增"' label=''>
        <el-radio-group size='mini' v-model='type' @input='clearYears'>
          <el-radio-button label='年'></el-radio-button>
          <el-radio-button label='月'></el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if='dialogTitle === "新增"' :label='type + "："'>
        <el-date-picker
          v-model='form.years'
          :type='type === "年" ? "year" :"month"'
          :value-format='type === "年" ? "yyyy" : "yyyyMM"'
          size='mini'
          placeholder='请选择年月'>
        </el-date-picker>
        <el-button size='small' class='searchBtn ml10'
                   @click='createList'>生成
        </el-button>
      </el-form-item>
      <div class='operation'>
        <div class='operationTitle' v-if='this.dialogTitle === "详情"'>
          <div class='line' />
          <span>{{ tableTitle }}</span>
        </div>
        <el-table
          ref='registerTable'
          v-loading='tableLoading'
          :data='form.values'
          class='mt10'
          style='width: 100%'
          border
          :header-cell-style='headerCellStyle'
        >
          <el-table-column prop='businessType' label='业务类型' align='center' width='80px' />
          <el-table-column label='营业收入（含内部交易）' align='center'>
            <template slot-scope='scope'>
              <el-form-item v-if='dialogTitle === "新增" || dialogTitle === "编辑"' label-width='0px'
                            :prop='`values[${scope.$index}].businessIncome`'
                            :rules='rules.businessIncome'>
                <el-input size='small' type='number' v-model='scope.row.businessIncome'
                          placeholder='请输入营业收入' />
              </el-form-item>
              <div v-else>{{ scope.row.businessIncome }}</div>
            </template>
          </el-table-column>
          <el-table-column label='营业成本（含内部交易）' align='center'>
            <template slot-scope='scope'>
              <el-form-item v-if='dialogTitle === "新增" || dialogTitle === "编辑"' label-width='0px'
                            :prop='`values[${scope.$index}].operatingCosts`'
                            :rules='rules.operatingCosts'>
                <el-input size='small' type='number' v-model='scope.row.operatingCosts'
                          placeholder='请输入营业成本' />
              </el-form-item>
              <div v-else>{{ scope.row.operatingCosts }}</div>
            </template>
          </el-table-column>
          <el-table-column label='资产净值（净额金额）' align='center'>
            <template slot-scope='scope'>
              <el-form-item v-if='dialogTitle === "新增" || dialogTitle === "编辑"' label-width='0px'
                            :prop='`values[${scope.$index}].netAssetValue`'
                            :rules='rules.netAssetValue'>
                <el-input size='small' type='number' v-model='scope.row.netAssetValue'
                          placeholder='请输入资产净值' />
              </el-form-item>
              <div v-else>{{ scope.row.netAssetValue }}</div>
            </template>
          </el-table-column>
          <el-table-column label='资产收入' align='center'>
            <template slot-scope='scope'>
              <el-form-item v-if='dialogTitle === "新增" || dialogTitle === "编辑"' label-width='0px'
                            :prop='`values[${scope.$index}].assetIncome`'
                            :rules='rules.assetIncome'>
                <el-input size='small' type='number' v-model='scope.row.assetIncome'
                          placeholder='请输入资产收入' />
              </el-form-item>
              <div v-else>{{ scope.row.assetIncome }}</div>
            </template>
          </el-table-column>
          <el-table-column label='资产成本' align='center'>
            <template slot-scope='scope'>
              <el-form-item v-if='dialogTitle === "新增" || dialogTitle === "编辑"' label-width='0px'
                            :prop='`values[${scope.$index}].assetCost`' :rules='rules.assetCost'>
                <el-input size='small' type='number' v-model='scope.row.assetCost'
                          placeholder='请输入资产成本' />
              </el-form-item>
              <div v-else>{{ scope.row.assetCost }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='operation' v-if='this.dialogTitle === "详情"'>
        <div class='operationTitle'>
          <div class='line' />
          <span>操作信息</span>
        </div>
        <div class='operationTable'>
          <el-table
            row-key='id'
            :data='operateRecordList'
            border
            :header-cell-style='headerCellStyle'>
            <el-table-column prop='createTime' label='操作时间' align='center' />
            <el-table-column prop='operateType' label='操作类型' align='center' />
            <el-table-column prop='operationName' label='操作人' align='center' />
            <el-table-column prop='remark' label='备注' align='center' />
          </el-table>
        </div>
      </div>

      <div class='flex-center-center mt10 mb20'
           v-if='dialogTitle === "编辑" || dialogTitle === "新增"'>
        <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'>确认
        </el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import {
    businessTypeQuery,
    netOperatingValueAdd,
    netOperatingValueDetails,
    netOperatingValueUpdate,
  } from '@/service/financial';

  export default {
    name: 'revenueAndExpenditureAndNetValueForm',
    data() {
      return {
        type: '年',
        dialogTitle: '',
        dialogVisible: false,
        dialogLoading: false,
        defaultForm: {},
        form: {
          years: '',
          values: [],
        },
        rules: {
          businessIncome: [{
            required: true,
            message: '请输入营业收入',
            trigger: 'blur',
          }],
          operatingCosts: [{
            required: true,
            message: '请输入营业收入',
            trigger: 'blur',
          }],
          netAssetValue: [{
            required: true,
            message: '请输入营业收入',
            trigger: 'blur',
          }],
          assetIncome: [{
            required: true,
            message: '请输入营业收入',
            trigger: 'blur',
          }],
          assetCost: [{
            required: true,
            message: '请输入营业收入',
            trigger: 'blur',
          }],
        },
        submitLoading: false,
        tableLoading: false,
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        tableTitle: '',
        operateRecordList: [],  // 操作数据
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      dialogOpen(title, row) {
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.dialogTitle = title;
        if (row) this.getDetails(row);
        this.dialogVisible = true;
      },
      async getDetails(row) {
        this.form.associationId = row.associationId;
        this.form.years = row.years;
        if (this.dialogTitle === '详情') this.tableTitle = `${row.years}${row.years.length === 6 ? '月' : '年'}营业收支及资产净值分板块情况（单位：万元）`;
        this.dialogLoading = true;
        const {
          status,
          message,
          data,
        } = await netOperatingValueDetails({
          associationId: row.associationId,
          type: this.dialogTitle === '编辑' ? 1 : 0,
        });
        this.dialogLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.form.values = data.values;
        this.operateRecordList = data.operateRecordList;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            let res = {};
            if (this.dialogTitle === '新增') {
              res = await netOperatingValueAdd(this.form);
            } else {
              res = await netOperatingValueUpdate(this.form);
            }
            if (res.status !== 0) return this.$message.warning(res.message);
            this.$message.success(res.message);
            this.$emit('searchBtn');
            this.dialogClose();
          }
        });
      },
      async createList() {
        if (this.form.years === null || this.form.years.length === 0) return this.$message.warning('请输入年份后生成列表');
        this.dialogLoading = true;
        this.form.values = [];
        const {
          status,
          message,
          data,
        } = await businessTypeQuery(this.form.years);
        this.dialogLoading = false;
        if (status !== 0) return this.$message.warning(message);
        data.forEach(item => {
          this.form.values.push({
            businessType: item.businessType,
            businessIncome: 0,
            operatingCosts: 0,
            netAssetValue: 0,
            assetIncome: 0,
            assetCost: 0,
          });
        });
      },
      clearYears() {
        this.form.years = '';
      },
    },
  };
</script>

<style lang='scss' scoped>
  .settlement-form {
    width: 90%;
    margin: 0 auto;
  }

  .el-input {
    width: 165px;
  }

  .el-form-item {
    margin-bottom: 0 !important;
  }

  .operation {
    display: flex;
    flex-direction: column;

    &Title {
      display: flex;
      align-items: flex-end;

      p {
        font-weight: 700;
        font-size: 14px;
        color: rgba(51, 136, 255, 1);
        margin-left: 10px;
      }
    }

    &Table {
      width: 100%;
      margin-top: 10px;

      ::v-deep {
        .el-table td, .el-table th {
          padding: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }
      }
    }
  }

  .line {
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
    margin-top: 20px;
  }

  .line + span {
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
</style>
